<template>
    <div class="modal fade" id="locations-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header text-secondary">
                    <h5 class="modal-title" id="exampleModalLabel">All Locations</h5>
                </div>
                <div class="modal-body">
                    <GoogleMap
                        style="height: 80vh"
                        ref="map"
                        @ready="getLocations">
                    </GoogleMap>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMap from "../elements/GoogleMap";
import ApiRequest from "../../../utils/api-request";
import SettingsMixin from "../../../mixins/SettingsMixin";
export default {
    name: "LocationsModal",
    components: {GoogleMap},
    mixins: [SettingsMixin],
    data() {
        return {
            modal: null,

        }
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('locations-modal'));
    },
    methods: {
        open() {
            this.modal.show();
            return this;
        },
        close() {
            this.modal.hide();
        },
        getLocations() {
            new ApiRequest().getLocations().then(
                (response) => {
                    response.data.data.forEach(location => {
                        if (!this.settings.altLocations.includes(location.id)
                            && this.settings.location.id !== location.id) return;

                        location.position = {
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng)
                        };
                        this.$refs.map.addMarker(location)
                    });
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
